/* HAYCH theme behaviour.

   Rules this file follows, because it runs on a live store:
   - the cart is never guessed at. Every change goes through Shopify's Ajax
     API and the drawer is re-rendered from the response.
   - the variant added to the cart is always the one in the form's id input.
     Size buttons only ever set that input; they never post on their own.
   - the express checkout buttons are Shopify's. Nothing here touches them. */

(function () {
  'use strict';

  var routes = (window.HAYCH && window.HAYCH.routes) || {};
  var strings = (window.HAYCH && window.HAYCH.strings) || {};

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  /* Shopify CDN honours a width param on any image URL. */
  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function money(cents) {
    var format = (window.HAYCH && window.HAYCH.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  // ------------------------------------------------------------ overlays

  var PANELS = { menu: '.menu', search: '.search', bag: '.drawer', filters: '.filters' };

  function setOpen(which, open) {
    Object.keys(PANELS).forEach(function (key) {
      var el = $(PANELS[key]);
      if (el) el.dataset.open = String(key === which && open);
    });
    var shop = $('.header__shop');
    if (shop) shop.setAttribute('aria-expanded', String(which === 'menu' && open));
    var overlay = $('.js-overlay');
    if (overlay) overlay.hidden = !open;
    document.body.classList.toggle('is-locked', !!open && which !== 'menu');
  }

  function closeDrawers() {
    ['.info', '.sizechart'].forEach(function (sel) {
      var el = $(sel);
      if (el) el.dataset.open = 'false';
    });
    setOpen(null, false);
  }

  function wireChrome() {
    var shop = $('.header__shop');
    var menu = $('.menu');
    if (shop && menu) {
      shop.addEventListener('click', function () {
        setOpen('menu', menu.dataset.open !== 'true');
      });
      menu.addEventListener('mouseleave', function () { setOpen(null, false); });
    }

    var searchBtn = $('.js-search');
    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        setOpen('search', true);
        var input = $('.js-search-input');
        if (input) input.focus();
      });
    }
    $$('.js-close-search').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(null, false); });
    });

    var bagBtn = $('.js-bag');
    if (bagBtn) {
      bagBtn.addEventListener('click', function (e) {
        // let the link work if JS-driven drawers are not available
        if (!$('.drawer')) return;
        e.preventDefault();
        setOpen('bag', true);
      });
    }
    $$('.js-close-bag').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(null, false); });
    });

    var openFilters = $('.js-open-filters');
    if (openFilters) {
      openFilters.addEventListener('click', function () { setOpen('filters', true); });
    }
    $$('.js-close-filters').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(null, false); });
    });

    var overlay = $('.js-overlay');
    if (overlay) overlay.addEventListener('click', closeDrawers);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawers();
    });

    $$('.footer__col > button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var col = btn.parentElement;
        col.setAttribute('aria-expanded', col.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
    });

    $$('.filters__heading').forEach(function (h) {
      h.addEventListener('click', function () {
        var g = h.parentElement;
        g.dataset.open = g.dataset.open === 'true' ? 'false' : 'true';
      });
    });

    // drag-to-scroll on every horizontal rail
    $$('[data-rail], .rail, .gallery__rail').forEach(enableDrag);
  }

  function enableDrag(rail) {
    if (!rail || rail.dataset.dragBound) return;
    rail.dataset.dragBound = '1';
    var down = false, startX = 0, startScroll = 0;
    rail.addEventListener('pointerdown', function (e) {
      down = true; startX = e.clientX; startScroll = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) rail.setPointerCapture(e.pointerId);
      rail.scrollLeft = startScroll - dx;
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      rail.addEventListener(ev, function () { down = false; });
    });
    rail.addEventListener('click', function (e) {
      if (Math.abs(rail.scrollLeft - startScroll) > 6) e.preventDefault();
    }, true);
  }

  // ---------------------------------------------------------------- cart

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  /* Re-render the drawer from the server's cart, never from local state. */
  function refreshCart() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;

        var badge = $('.js-bag-count');
        if (badge) { badge.textContent = count; badge.hidden = count === 0; }

        var total = $('.js-bag-total');
        if (total) total.textContent = '(' + count + ')';

        var subtotal = $('.js-subtotal');
        if (subtotal) subtotal.textContent = money(cart.total_price);

        var checkout = $('.js-checkout');
        if (checkout) checkout.disabled = count === 0;

        var body = $('.js-bag-body');
        if (body) body.innerHTML = renderLines(cart);
        return cart;
      });
  }

  function renderLines(cart) {
    if (!cart.items.length) {
      return '<p class="drawer__empty">' + escapeHtml(strings.cartEmpty || 'Your bag is empty') + '</p>';
    }
    return cart.items.map(function (item, i) {
      var line = i + 1;
      var img = item.image
        ? '<img src="' + escapeHtml(sized(item.image, 200)) + '" alt="" width="72" height="96" loading="lazy">'
        : '';
      var variant = item.product_has_only_default_variant ? '' : escapeHtml(item.variant_title || '');
      return '' +
        '<div class="line" data-line="' + line + '">' +
          '<a class="line__img" href="' + escapeHtml(item.url) + '">' + img + '</a>' +
          '<div class="line__info">' +
            '<a class="line__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
            '<span class="line__meta">' + variant + '</span>' +
            '<div class="line__qty">' +
              '<button type="button" data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<span class="line__price">' + money(item.final_line_price) + '</span>' +
        '</div>';
    }).join('');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function addToCart(variantId, quantity, button) {
    if (!variantId) return Promise.resolve();
    var label = button ? button.querySelector('.js-atc-text') || button : null;
    var original = label ? label.textContent : '';
    if (button) button.disabled = true;
    if (label) label.textContent = 'Adding…';

    return cartRequest(routes.cart_add + '.js', { items: [{ id: Number(variantId), quantity: quantity || 1 }] })
      .then(function () { return refreshCart(); })
      .then(function () { setOpen('bag', true); })
      .catch(function (err) {
        if (label) label.textContent = err.message || 'Could not add';
        window.setTimeout(function () { if (label) label.textContent = original; }, 2500);
        throw err;
      })
      .finally(function () {
        if (button) button.disabled = false;
        if (label && label.textContent === 'Adding…') label.textContent = original;
      });
  }

  var globalsBound = false;

  function wireCart() {
    var body = $('.js-bag-body');
    if (body && !body.dataset.bound) {
      body.dataset.bound = '1';
      body.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-line]');
        if (!btn) return;
        btn.disabled = true;
        cartRequest(routes.cart_change + '.js', {
          line: Number(btn.dataset.line),
          quantity: Number(btn.dataset.qty)
        }).then(refreshCart).catch(function () { btn.disabled = false; });
      });
    }

    if (globalsBound) return;
    globalsBound = true;

    // quick add from any product card
    document.addEventListener('click', function (e) {
      var quick = e.target.closest('[data-quick-add]');
      if (!quick || quick.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      addToCart(quick.dataset.quickAdd, 1, null);
    });

    // colourway dot on a card
    document.addEventListener('click', function (e) {
      var swatch = e.target.closest('.card__swatch[data-url]');
      if (!swatch) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = swatch.dataset.url;
    });
  }

  // ------------------------------------------------------------- product

  function wireProduct() {
    var block = $('.pdp__block');
    if (!block) return;

    var form = $('#ProductForm');
    var idInput = $('.js-variant-id', block);
    var sizes = $$('.pdp__size', block);
    var priceEl = $('.js-price', block);
    var chosen = $('.pdp__size-chosen', block);
    var stock = $('.pdp__size-stock', block);
    var atc = $('.js-atc', block);
    var atcText = $('.js-atc-text', block);

    /* Hand control to JavaScript: enable the hidden id input the size buttons
       drive, and switch off the select that exists only for the no-JS case.
       A disabled control is not submitted, so exactly one id ever posts. */
    if (idInput) idInput.disabled = false;
    $$('.js-nojs-select', block).forEach(function (sel) { sel.disabled = true; });

    var variants = [];
    var json = $('.js-product-json', block);
    if (json) {
      try { variants = JSON.parse(json.textContent); } catch (err) { variants = []; }
    }

    function variantById(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function select(button) {
      if (!button || button.disabled) return;
      sizes.forEach(function (b) { b.classList.remove('is-on'); });
      button.classList.add('is-on');

      var id = button.dataset.variantId;
      if (idInput) idInput.value = id;

      var variant = variantById(id);
      if (variant) {
        if (chosen) chosen.textContent = variant.title;
        if (stock) stock.textContent = variant.available ? (strings.inStock || 'In Stock') : '';
        if (priceEl) {
          priceEl.innerHTML = variant.compare_at_price > variant.price
            ? '<s>' + money(variant.compare_at_price) + '</s> <span class="is-sale">' + money(variant.price) + '</span>'
            : money(variant.price);
        }
        if (atc) atc.disabled = !variant.available;
        if (atcText) {
          atcText.textContent = variant.available
            ? (strings.addToCart || 'Add To Cart')
            : (strings.soldOut || 'Sold out');
        }
        // keep the URL shareable and the back button honest
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    sizes.forEach(function (button) {
      button.addEventListener('click', function () { select(button); });
    });

    /* Multi-option products: the visible select carries name="id" itself, so
       nothing needs copying. Just keep the price and button in step. */
    var liveSelect = block.querySelector('.js-variant-select:not(.js-nojs-select)');
    if (liveSelect) {
      liveSelect.addEventListener('change', function () {
        var v = variantById(liveSelect.value);
        if (!v) return;
        if (priceEl) {
          priceEl.innerHTML = v.compare_at_price > v.price
            ? '<s>' + money(v.compare_at_price) + '</s> <span class="is-sale">' + money(v.price) + '</span>'
            : money(v.price);
        }
        if (atc) atc.disabled = !v.available;
        if (atcText) {
          atcText.textContent = v.available ? (strings.addToCart || 'Add To Cart') : (strings.soldOut || 'Sold out');
        }
      });
    }

    /* Add to cart goes through the Ajax API so the drawer can open, but the
       form keeps its native action as a fallback if JS fails. */
    if (form) {
      form.addEventListener('submit', function (e) {
        var picker = idInput && !idInput.disabled ? idInput : liveSelect;
        if (!picker || !picker.value) return; // let Shopify handle it natively
        if (sizes.length && !$('.pdp__size.is-on', block)) {
          e.preventDefault();
          if (atcText) atcText.textContent = strings.selectSize || 'Select A Size';
          if (atc) atc.classList.add('is-prompt');
          var grid = $('.pdp__sizes', block);
          if (grid) {
            grid.classList.add('is-prompt');
            window.setTimeout(function () { grid.classList.remove('is-prompt'); }, 1200);
          }
          return;
        }
        e.preventDefault();
        if (atc) atc.classList.remove('is-prompt');
        addToCart(picker.value, 1, atc);
      });
    }

    // gallery
    var slides = $('.pdp__slides');
    if (slides) {
      var index = 0;
      var count = slides.children.length;
      var indicator = $('.js-slide');
      var go = function (n) {
        index = (n + count) % count;
        slides.scrollTo({ left: slides.clientWidth * index, behavior: 'smooth' });
      };
      var prev = $('.pdp__nav--prev');
      var next = $('.pdp__nav--next');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      slides.addEventListener('scroll', function () {
        var n = Math.round(slides.scrollLeft / slides.clientWidth);
        if (n !== index) { index = n; if (indicator) indicator.textContent = index + 1; }
      }, { passive: true });
    }

    // accordions
    $$('.acc__head').forEach(function (h) {
      h.addEventListener('click', function () {
        var acc = h.parentElement;
        acc.dataset.open = acc.dataset.open === 'true' ? 'false' : 'true';
      });
    });

    // size chart drawer
    var chart = $('.sizechart');
    $$('.js-sizechart').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!chart) return;
        chart.dataset.open = 'true';
        document.body.classList.add('is-locked');
      });
    });
    var closeChart = $('.js-close-sizechart');
    if (closeChart) {
      closeChart.addEventListener('click', function () {
        chart.dataset.open = 'false';
        document.body.classList.remove('is-locked');
      });
    }

    // detail row drawers
    var info = $('.info');
    $$('.js-usp').forEach(function (row) {
      row.addEventListener('click', function () {
        if (!info) return;
        $('h5', info).textContent = row.dataset.title || '';
        $('.info__body', info).innerHTML = '<p>' + escapeHtml(row.dataset.body || '').replace(/\n+/g, '</p><p>') + '</p>';
        info.dataset.open = 'true';
        document.body.classList.add('is-locked');
      });
    });
    var closeInfo = $('.js-close-info');
    if (closeInfo) {
      closeInfo.addEventListener('click', function () {
        info.dataset.open = 'false';
        document.body.classList.remove('is-locked');
      });
    }
  }

  // -------------------------------------------------------- collection

  function wireCollection() {
    var grid = $('.grid');
    if (!grid) return;

    var toggle = $('.view-toggle');
    if (toggle) {
      var view = Number(window.localStorage.getItem('haych-view')) || 2;
      var paint = function () {
        grid.dataset.view = view;
        $$('.view-toggle span').forEach(function (s) {
          s.classList.toggle('is-on', Number(s.dataset.view) === view);
        });
      };
      paint();
      toggle.addEventListener('click', function () {
        view = view >= 3 ? 1 : view + 1;
        window.localStorage.setItem('haych-view', view);
        paint();
      });
    }

    var model = $('.model-toggle');
    if (model) {
      var on = window.localStorage.getItem('haych-model') !== 'false';
      var applyModel = function () {
        document.body.classList.toggle('show-model', on);
        model.setAttribute('aria-pressed', String(on));
        window.localStorage.setItem('haych-model', String(on));
      };
      applyModel();
      model.addEventListener('click', function () { on = !on; applyModel(); });
    }

    /* Sorting posts the form immediately; the facets wait for Apply so a
       shopper can tick several without a reload between each. */
    $$('[data-sort] input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var form = $('.js-filter-form');
        if (form) form.submit();
      });
    });
  }

  // ------------------------------------------------------------- search

  var searchTimer = null;

  function wireSearch() {
    var input = $('.js-search-input');
    var results = $('.js-search-results');
    if (!input || !results || !routes.predictive_search) return;

    input.addEventListener('input', function () {
      var term = input.value.trim();
      window.clearTimeout(searchTimer);
      if (term.length < 2) { results.innerHTML = ''; return; }
      searchTimer = window.setTimeout(function () {
        var url = routes.predictive_search +
          '?q=' + encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=12&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('.js-search-results-inner');
            results.innerHTML = inner ? inner.innerHTML : '';
            enableDrag(results.querySelector('[data-rail]'));
          })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
    });
  }

  // ----------------------------------------------------------- brand film

  function wireVideo() {
    var video = $('.js-about-video');
    var sound = $('.js-sound');
    if (!video) return;

    /* Reduced motion: no autoplay, no loop, give the viewer a still and a
       normal player instead, and drop the sound button since controls cover it. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.removeAttribute('autoplay');
      video.removeAttribute('loop');
      video.controls = true;
      video.pause();
      if (sound) sound.hidden = true;
      return;
    }

    if (!sound || sound.dataset.bound) return;
    sound.dataset.bound = '1';

    sound.addEventListener('click', function () {
      video.muted = !video.muted;
      // Safari leaves the element paused when autoplay was blocked
      if (video.paused) {
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      }
      sound.textContent = video.muted
        ? (strings.soundOn || 'Sound On')
        : (strings.soundOff || 'Sound Off');
      sound.setAttribute('aria-pressed', String(!video.muted));
    });
  }

  // ---------------------------------------------- product recommendations

  function loadRecommendations() {
    var el = $('[data-recommendations]');
    if (!el || !el.dataset.url) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh) {
          el.innerHTML = fresh.innerHTML;
          enableDrag(el.querySelector('[data-rail]'));
        }
      })
      .catch(function () { /* a missing rail is not worth breaking the page for */ });
  }

  // ---------------------------------------------------------------- boot

  function boot() {
    wireChrome();
    wireCart();
    wireProduct();
    wireCollection();
    wireSearch();
    wireVideo();
    loadRecommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // the theme editor re-renders sections in place
  document.addEventListener('shopify:section:load', boot);
}());
